import { ref } from 'vue'

export type CopyState = 'idle' | 'copied' | 'failed'

/**
 * Copy-to-clipboard with an honest failure. Clipboard access is refused outside a secure context
 * and under some policies, so a failure reveals the text for manual selection rather than
 * pretending the copy happened.
 */
export function useCopyButton(text: () => string, resetMs = 2500) {
	const state = ref<CopyState>('idle')
	let resetTimer: ReturnType<typeof setTimeout> | undefined

	async function copy() {
		clearTimeout(resetTimer)

		try {
			await navigator.clipboard.writeText(text())
			state.value = 'copied'
			resetTimer = setTimeout(() => { state.value = 'idle' }, resetMs)
		} catch {
			state.value = 'failed'
		}
	}

	return { state, copy }
}
